// extracted by mini-css-extract-plugin
export default {"form":"Form_form__B093r"};